import { render, staticRenderFns } from "./ArtikelAppView.vue?vue&type=template&id=150812be&scoped=true"
import script from "./ArtikelAppView.vue?vue&type=script&lang=js"
export * from "./ArtikelAppView.vue?vue&type=script&lang=js"
import style0 from "./ArtikelAppView.vue?vue&type=style&index=0&id=150812be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150812be",
  null
  
)

export default component.exports